// EAN scanner v novej wrapper appke (r-flutter-wrapper): namiesto in-page
// ZXing skenera (camera-scanner.js) volá natívny scanner cez bridge akciu
// SCAN_BARCODE. Mimo appky (web, Median, starý B2B wrapper) je modul inertný.
//
// Zámerne bez importov ZXing/jQuery — UI helpery z camera-scanner.js berie
// lazy cez window.__eanScannerUi, aby sa dal evalovať v legacy-coexistence
// teste. Musí sa importovať PO camera-scanner.js (components/header.js).

const SCAN_FORMATS = ["ean13", "ean8", "upcA", "upcE"];

let scanInFlight = false;

function ui() {
    return window.__eanScannerUi || null;
}

function messageDataset() {
    const el = document.querySelector(".js-ean-scanner-message");
    return (el && el.dataset) || {};
}

function showError(text, retryHandler, retryLabel) {
    const scannerUi = ui();
    if (!scannerUi) {
        return;
    }
    scannerUi.setRetryHandler(retryHandler);
    scannerUi.openResultModal();
    scannerUi.showResultError(text, retryLabel);
}

async function startNativeScan() {
    const scannerUi = ui();
    if (!scannerUi || scanInFlight) {
        return;
    }

    scanInFlight = true;
    let result;

    try {
        // Bez timeoutu — natívny scanner môže byť otvorený ľubovoľne dlho
        result = await window.AppBridge.callBridge("SCAN_BARCODE", {
            formats: SCAN_FORMATS,
        });
    } catch (error) {
        scanInFlight = false;
        console.error("SCAN_BARCODE failed", error);
        showError(messageDataset().cameraErrorApp || "Skener sa nepodarilo otvoriť.", () =>
            startNativeScan()
        );
        return;
    }

    scanInFlight = false;

    switch (result.status) {
        case "scanned":
            // Rovnaké spracovanie ako web scanner: POST /vyhladavanie-ean,
            // redirect na produkt alebo error message v modal overlayi.
            // Retry = rovno nový natívny sken. Modal sa pri ňom zámerne
            // NEzatvára — natívny scanner zapauzuje WebView, Bootstrap hide
            // transition by sa nedokončila a modal by sa zasekol v medzistave.
            scannerUi.setRetryHandler(() => {
                startNativeScan();
            });
            scannerUi.openResultModal();
            scannerUi.processScannedCode(result.value);
            break;

        case "permissionDenied":
            // Retry tlačidlo otvorí systémové nastavenia appky
            showError(
                messageDataset().cameraDeniedApp ||
                    "Prístup ku kamere bol zamietnutý. Povoľte kameru v nastaveniach aplikácie.",
                () => {
                    window.AppBridge.callBridge("OPEN_APP_SETTINGS").catch(() => {});
                },
                messageDataset().openSettingsLabel || "Otvoriť nastavenia"
            );
            break;

        case "unavailable":
            showError(messageDataset().cameraErrorApp || "Kameru sa nepodarilo otvoriť.", () =>
                startNativeScan()
            );
            break;

        case "cancelled":
            // User natívny scanner zavrel — ak ostal otvorený result modal
            // (retry flow), zavri ho; inak je hide no-op.
            scannerUi.closeModal();
            break;

        // busy — scanner už beží (double-tap), nič nerobíme
        default:
            break;
    }
}

if (window.AppBridge && window.AppBridge.isApp) {
    // Capture-phase listener predbehne Bootstrap data-api (delegovaný bubble
    // listener na document) — modal s kamerou sa v appke vôbec neotvorí.
    document.addEventListener(
        "click",
        (event) => {
            const trigger =
                event.target && event.target.closest
                    ? event.target.closest('[data-target="#ean-scanner"]')
                    : null;
            if (!trigger) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            startNativeScan();
        },
        true
    );
}
